export default {"src":"/_next/static/media/red-check.58ada2b2.svg","height":9,"width":12};